import { useCallback, useRef } from 'react';

/**
 * Starts a request and returns a check that stays true only while no newer request has started,
 * so a slow earlier response cannot overwrite a newer one.
 */
export const useLatestRequest = (): (() => () => boolean) => {
  const latest = useRef(0);

  return useCallback(() => {
    const id = ++latest.current;
    return () => id === latest.current;
  }, []);
};

export default useLatestRequest;
